<section id="charts-presentation" class="presentation-slider dingo-bg-base section-first" #chartsPresentation>
  <div class="presentation-shell">
    @if (presentationSlides[3]) {
    <div class="presentation-impact-layer" [class.is-active]="activePresentationIndex === 3" aria-hidden="true">
      <div
        class="presentation-impact-layer-bg"
        [style.background-image]="'url(\'' + presentationSlides[3].visual + '\')'"
      ></div>
      <div class="presentation-impact-layer-scrim"></div>
    </div>
    }

    <div class="presentation-noise" aria-hidden="true"></div>
    <aside class="presentation-bullets" aria-label="Navegación de slides">
      @for (slide of presentationSlides; track slide.id; let i = $index) {
      <button
        type="button"
        class="presentation-bullet"
        [class.is-active]="i === activePresentationIndex"
        (click)="presentationSlideRequested.emit(i)"
        [attr.aria-label]="'Ir al slide ' + presentationStepLabel(i)"
      >
        <span></span>
      </button>
      }
    </aside>

    <div class="presentation-slides">
      @for (slide of presentationSlides; track slide.id; let i = $index) {
      <article
        class="presentation-slide"
        [class.is-active]="i === activePresentationIndex"
        [class.presentation-slide--hero]="i === 0"
        [class.presentation-slide--chart]="i === 1"
        [class.presentation-slide--dual-chart]="i === 2"
        [class.presentation-slide--impact]="i === 3"
      >
        @if (i === 0) {
        <div class="presentation-copy">
          <p class="presentation-eyebrow presentation-anim">{{ presentationHero.caption }}</p>
          <h3 class="presentation-anim">
            <span class="presentation-title-main">{{ presentationHero.title }}</span>
            <span class="presentation-title-outline">{{ presentationHero.highlight }}</span>
          </h3>
          <p class="presentation-description presentation-anim">{{ presentationHero.subtitle }}</p>
          <a class="presentation-cta dingo-cta-primary presentation-anim" [href]="presentationHero.primaryCtaUrl" target="_blank" rel="noopener">
            {{ presentationHero.primaryCtaText }}
          </a>
        </div>

        <div class="presentation-visual presentation-visual--hero">
          <div class="hero-visual-shell presentation-anim">
            <div
              class="hero-visual-stack"
              [style.--hero-track-rotate-x]="heroTrackerRotateX"
              [style.--hero-track-rotate-y]="heroTrackerRotateY"
              [style.--hero-track-x]="heroTrackerOffsetX"
              [style.--hero-track-y]="heroTrackerOffsetY"
              [style.--hero-glow-x]="heroTrackerGlowX"
              [style.--hero-glow-y]="heroTrackerGlowY"
              (mousemove)="heroTrackerMove.emit($event)"
              (mouseleave)="heroTrackerLeave.emit()"
            >
              <img
                [src]="presentationHero.image"
                [alt]="presentationHero.imageAlt"
                class="img-fluid hero-dashboard-image presentation-anim"
                loading="eager"
                decoding="async"
                fetchpriority="high"
              />

              @for (card of presentationHero.cards; track card.id) {
              <article class="hero-float-card" [ngClass]="'hero-float-card--' + card.variant">
                <span class="hero-float-label">{{ card.label }}</span>
                @if (card.value) {
                <strong class="hero-float-value">{{ card.value }}</strong>
                }
                <small>{{ card.detail }}</small>
              </article>
              }
            </div>
          </div>
        </div>
        } @else if (i === 1) {
        <div class="presentation-visual presentation-visual--chart">
          <div class="presentation-chart-stage presentation-anim">
            <canvas class="presentation-chart-canvas" data-market-chart aria-label="Gráfica de mejora estimada de ROAS"></canvas>
            <p class="presentation-chart-caption">ROAS estimado por etapa de optimización</p>
          </div>
        </div>

        <div class="presentation-copy presentation-copy--chart">
          <p class="presentation-eyebrow presentation-anim">{{ slide.eyebrow }}</p>
          <h3 class="presentation-anim">
            <span class="presentation-title-main">{{ slide.titleMain }}</span>
            <span class="presentation-title-outline">{{ slide.titleOutline }}</span>
          </h3>
          <p class="presentation-description presentation-anim">{{ slide.description }}</p>
          <a class="presentation-cta dingo-cta-primary presentation-anim" [href]="slide.ctaUrl">
            {{ slide.ctaText }}
          </a>
        </div>
        } @else if (i === 2) {
        <div class="presentation-copy presentation-copy--dual-chart">
          <p class="presentation-eyebrow presentation-anim">{{ slide.eyebrow }}</p>
          <h3 class="presentation-anim">
            <span class="presentation-title-main">{{ slide.titleMain }}</span>
            <span class="presentation-title-outline">{{ slide.titleOutline }}</span>
          </h3>
          <p class="presentation-description presentation-anim">{{ slide.description }}</p>
        </div>

        <div class="presentation-dual-charts presentation-anim">
          <div class="presentation-chart-panel">
            <div class="presentation-chart-panel-stage">
              <canvas data-audience-age-chart aria-label="Gráfica de embudo de conversión"></canvas>
            </div>
            <p class="presentation-chart-panel-title">Embudo de conversión</p>
          </div>
          <div class="presentation-chart-panel">
            <div class="presentation-chart-panel-stage presentation-chart-panel-stage--legend">
              <canvas data-audience-gender-chart aria-label="Gráfica de crecimiento de clientes por campaña"></canvas>
            </div>
            <p class="presentation-chart-panel-title">Clientes generados por campaña</p>
          </div>
        </div>

        <a class="presentation-cta dingo-cta-primary presentation-anim presentation-cta--dual-chart" [href]="slide.ctaUrl">
          {{ slide.ctaText }}
        </a>
        } @else if (i === 3) {
        <div class="presentation-impact presentation-anim">
          <div class="presentation-impact-inner">
            <div class="presentation-copy presentation-copy--impact">
              <p class="presentation-eyebrow presentation-anim">{{ slide.eyebrow }}</p>
              <h3 class="presentation-anim">
                <span class="presentation-title-main">{{ slide.titleMain }}</span>
                <span class="presentation-title-outline">{{ slide.titleOutline }}</span>
              </h3>
              <p class="presentation-description presentation-anim">{{ slide.description }}</p>
            </div>

            <div class="presentation-impact-chart-wrap presentation-anim">
              <div class="presentation-impact-chart-stage">
                <canvas data-impact-bar-chart [attr.aria-label]="'Gráfica de impacto por canal'"></canvas>
              </div>
              @if (slide.chartFootnote) {
              <p class="presentation-impact-chart-foot">{{ slide.chartFootnote }}</p>
              }
            </div>

            <a class="presentation-cta dingo-cta-primary presentation-anim presentation-cta--impact" [href]="slide.ctaUrl">
              {{ slide.ctaText }}
            </a>
          </div>
        </div>
        } @else {
        <div class="presentation-copy">
          <p class="presentation-eyebrow presentation-anim">{{ slide.eyebrow }}</p>
          <h3 class="presentation-anim">
            <span class="presentation-title-main">{{ slide.titleMain }}</span>
            <span class="presentation-title-outline">{{ slide.titleOutline }}</span>
          </h3>
          <p class="presentation-description presentation-anim">{{ slide.description }}</p>
          <a class="presentation-cta dingo-cta-primary presentation-anim" [href]="slide.ctaUrl">
            {{ slide.ctaText }}
          </a>
        </div>

        <div class="presentation-visual">
          <div class="presentation-visual-inner">
            <div class="presentation-visual-orb presentation-anim" [style.background]="slide.orbGradient"></div>
            <img class="img-fluid presentation-visual-img presentation-anim" [src]="slide.visual" [alt]="slide.visualAlt" />
          </div>
        </div>
        }
      </article>
      }
    </div>

    <div class="presentation-index">
      <span>{{ presentationStepLabel(activePresentationIndex) }}</span>
      <small>/ {{ presentationStepLabel(presentationSlides.length - 1) }}</small>
    </div>

    <div class="presentation-scroll-hint">
      <span>scroll</span>
      <span class="presentation-scroll-line" aria-hidden="true"></span>
    </div>

    <aside class="presentation-social" aria-label="Redes sociales">
      <a href="https://www.facebook.com/profile.php?id=100063605347598" target="_blank" rel="noopener" aria-label="Facebook">
        <i class="bi bi-facebook"></i>
      </a>
      <a
        href="https://www.instagram.com/dingomarketing_?igsh=MWY0cXRzNTM1dHNraA%3D%3D&utm_source=qr"
        target="_blank"
        rel="noopener"
        aria-label="Instagram"
      >
        <i class="bi bi-instagram"></i>
      </a>
      <a href="https://wa.me/5215543581515" target="_blank" rel="noopener" aria-label="WhatsApp">
        <i class="bi bi-whatsapp"></i>
      </a>
    </aside>
  </div>
</section>
